export const SN_CATALOG = 'catalog'
export const SET_STOCK_CACHE = `${SN_CATALOG}/SET_STOCK_CACHE`
export const SET_STOCK_CACHE_PRODUCT = `${SN_CATALOG}/SET_STOCK_CACHE_PRODUCT`
export const SET_IS_STOCK_INFO_LOADING = `${SN_CATALOG}/SET_IS_STOCK_INFO_LOADING`
export const SET_MAX_QUANTITY = `${SN_CATALOG}/SET_MAX_QUANTITY`
